import { EntityRisk } from "../../../../../utils/constants";
import {
  IntegrationCategory,
  IntegrationsMapping,
} from "../../../integrations/IntegrationsMapping";
import { getRiskNameFromValue } from "../../utils";

const { filterName } = require("../utils");

export const highRisksOptions = [
  getRiskNameFromValue(EntityRisk.CRITICAL),
  getRiskNameFromValue(EntityRisk.HIGH),
];

export const areAllFiltersNotApplied = ({
  appliedFilters,
  excludedFilterNames = [],
}) =>
  Object.entries(appliedFilters)
    .filter(([filter, _]) => !excludedFilterNames.includes(filter))
    .every(([filter, filterValue]) => {
      if (filter === filterName.SEARCH_STRING) return filterValue === "";
      else
        return (
          Object.keys(filterValue).length === 0 ||
          Object.values(filterValue).every((checked) => !checked)
        );
    });

export const areHighRisksApplied = (appliedFilters) =>
  highRisksOptions.every((risk) => appliedFilters[filterName.RISK]?.[risk]) &&
  Object.keys(appliedFilters[filterName.RISK])
    .filter((risk) => !highRisksOptions.includes(risk))
    .every((risk) => !appliedFilters[filterName.RISK]?.[risk]);

export const createEmptyFilters = (appliedFilters) =>
  Object.fromEntries(
    Object.keys(appliedFilters).map((filter) =>
      filter === filterName.SEARCH_STRING
        ? [filter, ""]
        : filter === filterName.MY_FAVORITES
        ? [filter, false]
        : [filter, {}]
    )
  );

export const EDRTools = Object.values(IntegrationsMapping)
  .filter((tool) => tool.category === IntegrationCategory.EDR)
  .map((tool) => tool.codeName);

export const isMissingEDRApplied = (fetchedEntities, appliedFilters) => {
  const sources = new Set(fetchedEntities.flatMap((entity) => entity.sources));
  return Array.from(sources).every((tool) => {
    if (EDRTools.includes(tool))
      return appliedFilters[filterName.EXCLUDE_SOURCE]?.[tool];
    else return !appliedFilters[filterName.EXCLUDE_SOURCE]?.[tool];
  });
};

export const MDMTools = Object.values(IntegrationsMapping)
  .filter((tool) => tool.category === IntegrationCategory.MDM)
  .map((tool) => tool.codeName);

export const isMissingMDMApplied = (fetchedEntities, appliedFilters) => {
  const sources = new Set(fetchedEntities.flatMap((entity) => entity.sources));
  return Array.from(sources).every((tool) => {
    if (MDMTools.includes(tool))
      return appliedFilters[filterName.EXCLUDE_SOURCE]?.[tool];
    else return !appliedFilters[filterName.EXCLUDE_SOURCE]?.[tool];
  });
};
